import http from "./httpService";
import getApiEndpoint from "./apiEndpoint";
import { IdType, RemoteVehicleData, Vehicle, VinVehicle } from "../types/appTypes";

const apiEndpoint = `${getApiEndpoint()}/misc/vinDetails`;


export function getVinDetails(vin: string) {
  return http.get<VinVehicle>(`${apiEndpoint}/${vin}`);
}

// Route::post('{vin}/getRemoteData'
type getRemoteDataConfig = {
  items: ("dmr" | "dat")[];
  forceFresh?: boolean;
  vin?: string | null;
  motorAtlasId?: string | null | number;
}
export function getRemoteData(data: getRemoteDataConfig) {
  return http.post<{ data: RemoteVehicleData }>(`${getApiEndpoint()}/vehicleValuation/getRemoteData`, data);
}

export function getValuationValue(vin: string, data: { dataPoint: "salesPrice", firstRegDate: string, mileage: number }) {
  return http.post<{ data: number }>(`${getApiEndpoint()}/vehicleValuation/getValuationValue`, { ...data, vin })
}

export function patchVehicle(vehicleId: IdType, vehicle: Partial<Vehicle> & { enrich?: boolean }) {
  return http.patch<Vehicle>(`${getApiEndpoint()}/vehicle/${vehicleId}`, vehicle)
}
